import React from 'react'

import bg7 from '../images/bg8.jpg'

const aboutPage = () => (
	<main id="main" role="main">
		<section className="intro-block">
			<div className="parallax-bg">
				<img src={bg7} alt="image description" />
			</div>
			<div className="intro-text">
				<div
					className="align"
					data-100-top="opacity:1; transform: translatey(0px);"
					data--100-top="opacity:0; transform: translatey(100px);"
				>
					<p>
						LocusLabs is building the platform which enables everyone in
						buildings to manage, measure, and communicate everything about
						their physical space.
					</p>
				</div>
			</div>
		</section>
		<section className="about-section">
			<div className="container">
				<div className="content-blocks" style={{padding:'0'}}>
					<div
						className="block"
						data-bottom-top="opacity:0"
						data-50-bottom="opacity:1"
					>
						<h2>Our Story</h2>


<p>LocusLabs is an early-stage technology company founded in 2014 on the premise that the <b>physical world needs an accurate digital counterpart and corresponding software platform</b> to make it more accessible and more efficient. People’s increasing reliance on mobile navigation, the push to make buildings and campuses smarter and more efficient, supply chain optimization and autonomy, and the rise of augmented reality are just a few of the factors driving this need.</p>

<p>This digital counterpart of the physical world requires higher fidelity and accuracy than traditional mapping solutions. It requires higher dimensionality in both time, as the world changes and people and assets move, and space as buildings have a substantial 3D component. It must work indoors and out to bridge the solution gap within the buildings and campuses where so much of business and life take place. Finally, it requires a value proposition and business model that work for private and quasi-public spaces with a multitude of stakeholders, existing technologies and competing priorities.</p>

<p>When we started, we found a smattering of custom built applications along with monolithic GIS platforms built by engineers for engineers. We envision a geodata platform that is both easy-to-use and accessible by every stakeholder, regardless of where they reside in the organization.</p>

<p>Our growing team of brilliant thinkers, designers, cartographers, engineers, and operations experts across the globe is the heart of LocusLabs. Our passion drives us to craft amazing products that bring a new dimension of efficiency and make an enormous impact on the built world and the people who are a part of it. We absolutely love what we do.</p>

			 </div>
				</div>
				<aside
					className="aside"
					data-bottom-top="transform: translatey(100px); opacity:0;"
					data-100-bottom="opacity:1"
					data-center="transform: translatey(0px); opacity:1"
				>
					<h2>JOIN OUR TEAM</h2>
					<ul className="team-list">
					</ul>
				</aside>
			</div>
		</section>
	</main>
)

function renderJobs()
{
	if(typeof document !== "undefined")
	{
		var teamListNode = document.querySelector(".team-list")
		if(!teamListNode || !window.jobs)
		{
			setTimeout(renderJobs, 1000)
			return
		}

		teamListNode.innerHTML = Object.values(jobs.objects).map(mkJob).join("\n")
	}
}

function mkJob(job)
{
	return `<li key=${ job.id }>
			 <h3>
					<a href="${ job.hosted_url }">${ job.title }</a>
				</h3>
				<h4>${ job.is_remote_allowed ? "Anywhere!" : job.location.city + ", " + job.location.country }</h4>
		</li>`
}

export default aboutPage

renderJobs()


// WEBPACK FOOTER //
// ./src/pages/about.js